export default "__VITE_PUBLIC_ASSET__f6683884__"